<template>
  <div>
    <kn-jumbotron></kn-jumbotron>
    <!-- Use a fluid container for full-width layout -->
    <b-container fluid class="px-4 pb-5">
      <b-row class="justify-content-center mx-auto" style="max-width: 1400px;">
        <kn-sideMenu></kn-sideMenu>
        <main role="main" class="col-md-9 pl-md-5">
          <kn-carousel></kn-carousel>
          <div class="content-card">
            <h2 class="section-title">
              <span class="blue-accent"></span>Τελευταίο Φύλλο
            </h2>

            <div class="pdf-toolbar mb-3 d-flex justify-content-center justify-content-md-end">
              <a :href="latestPdfUrl" target="_blank" class="btn btn-sm btn-outline-primary pdf-btn">
                <i class="fa-solid fa-expand mr-1"></i> Προβολή σε πλήρη οθόνη
              </a>
            </div>

            <div class="pdf-wrapper">
              <iframe class="modern-pdf-iframe" :src="latestPdfUrl" allowfullscreen>
              </iframe>
            </div>
          </div>
        </main>
      </b-row>
    </b-container>

    <kn-footer></kn-footer>
  </div>
</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import carousel from "./carousel.vue";
import footer from "./footer.vue";

export default {
  components: {
    "kn-jumbotron": jumbotron,
    "kn-sideMenu": sideMenu,
    "kn-carousel": carousel,
    "kn-footer": footer
  },
  data() {
    return {
      latestPdfUrl: "https://www.kimoliaka-nea.gr/efimerides/efimerida_MAIOS-IOYN_2026.pdf", // Fallback Default
      msg: "Welcome to Your Vue.js App"
    }
  },
  mounted() {
    // Automatically fetch the latest issue config with a cache-busting query parameter
    fetch("https://www.kimoliaka-nea.gr/efimerides/latest-issue.json?t=" + new Date().getTime())
      .then(response => {
        if (!response.ok) throw new Error("Could not fetch latest issue config");
        return response.json();
      })
      .then(data => {
        if (data && data.latestPdfUrl) {
          this.latestPdfUrl = data.latestPdfUrl;
        }
      })
      .catch(err => {
        console.warn("Using fallback PDF due to fetch error or missing file:", err);
      });
  }
}
</script>

<style lang="scss" scoped>
.content-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(2, 132, 199, 0.1), 0 8px 10px -6px rgba(2, 132, 199, 0.05);
  padding: 2.5rem;
  margin-bottom: 2rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-top: 5px solid #0284c7;
}

.content-card:hover {
  box-shadow: 0 20px 25px -5px rgba(2, 132, 199, 0.15), 0 10px 10px -5px rgba(2, 132, 199, 0.08);
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.75rem;
  color: #0c4a6e;
  border: none;
  font-weight: 700;
}

.blue-accent {
  background: #0ea5e9;
  display: inline-block;
  width: 6px;
  height: 28px;
  margin-right: 12px;
  border-radius: 4px;
}

/* PDF Modernization Styles */
.pdf-toolbar {
  border-bottom: 1px solid #e0f2fe;
  padding-bottom: 0.5rem;
}

.pdf-btn {
  color: #0284c7;
  border-color: #0284c7;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.pdf-btn:hover {
  background-color: #0284c7;
  color: #ffffff;
}

@media (max-width: 767.98px) {
  .pdf-btn {
    width: 100%;
    padding: 0.6rem;
    font-size: 1rem;
  }
}

.pdf-wrapper {
  width: 100%;
  /* A4 paper aspect ratio is ~ 1:1.414. We enforce a portrait look so the newspaper isn't swallowed by thick gray margins */
  aspect-ratio: 1 / 1.414;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border: 4px solid #f8fafc;
  background-color: #f1f5f9;
  position: relative;
}

/* Fallback for older browsers that don't support aspect-ratio */
@supports not (aspect-ratio: 1 / 1.414) {
  .pdf-wrapper {
    height: 80vh;
  }
}

.modern-pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/mainContainer.vue